import { TComponent } from '@fe-learner-common';

export const eventTypes = ['ev_classroom', 'ev_virtual', 'ev_call'] as const;
export const eventTypesSet = new Set(eventTypes);
export type TEventType = (typeof eventTypes)[number];

export type IEventActivity = TComponent & {
  type: TEventType;
  eventTitle: string;
  activityStatus?: string | null;
  activityTitle?: string | null;
  activityEnabled: boolean;
};
